import { createQueryClient } from "@arcadeai/ui-kit/query-client";
import { toast } from "sonner";
import {
  getHttpErrorFields,
  isAuthRecoveryHttpError,
  isHttpError,
} from "./http-error";

export const queryClient = createQueryClient({
  onMutationError: (error, errorMessage = "An error occurred") => {
    if (isAuthRecoveryHttpError(error)) {
      return;
    }

    if (isHttpError(error)) {
      const { name, message } = getHttpErrorFields(error);
      toast.error(`${name}: ${message}`);
    } else {
      toast.error(error instanceof Error ? error.message : errorMessage);
    }
  },
  shouldRetry: (failureCount, error) => {
    if (isHttpError(error) && error.status === 401) {
      return false;
    }
    return failureCount < 1;
  },
});
